export enum CategorizationTypeEnum {
    DP_MANAGED = 'dp_managed',
    INTERNAL = 'internal'
}
